import React, { useMemo} from 'react';
import { Flex, Empty, Spin } from "antd";
import withAntDPagination from "./higherOrderComponents/withAntDPagination";

const ListAntD = (props) => {
    const {
        data = [],
        showBackgroundOnHover = true,
        removeListPadding = false,
        pagingData = null,
        pagingDependencies,
        loading = false,
        disableTabbing = false,
        noDataMessage = 'No results found',
        renderItem,
        roving = {},
        ...rest
    } = props;

    const renderRow = (item, index) => (
        <div
            key={item.id || index}
            role="listitem"
            className={`ch-list-item ${showBackgroundOnHover ? 'ch-bg-hover-highlight' : 'no-bottom-border'} ${rest.className || ''}`}
            style={{
                padding: removeListPadding ? 0 : '12px 0',
                outline: 'none'
            }}
        >
            {renderItem ? renderItem(item, index) : item}
        </div>
    );

    if (pagingData !== null) {
        if (typeof pagingData.fetchFunction !== 'function') {
            console.error('AntD pagingData fetchFunction must be a function.');
            return null;
        }

        const PagedList = useMemo(() =>
                withAntDPagination(Flex, pagingData.fetchFunction, pagingData.params, pagingData.onReady),
            Array.isArray(pagingDependencies) ? pagingDependencies : []
        );

        return (
            <PagedList
                roving={roving}
                {...rest}
                loading={loading}
                locale={{ emptyText: typeof noDataMessage === 'string' ? <span className="ch-warning-text">{noDataMessage}</span> : noDataMessage }}
            >
                {(item, index) => renderRow(item, index)}
            </PagedList>
        );
    }

    return (
        <Flex
            vertical
            role={data.length > 0 ? "list" : "none"}
            gap="small"
            className={rest.className}
            {...roving}
            {...rest}
        >
            {loading && <Spin />}
            {data.length > 0 ? (
                data.map((item, index) => renderRow(item, index))
            ) : (typeof noDataMessage === 'string' ? <span className="ch-warning-text">{noDataMessage}</span> : noDataMessage)}
        </Flex>
    );
}

export default ListAntD;